var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResturantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9822 6.38756L17.9075 2.08644C17.7757 1.558 17.3007 1.1875 16.7556 1.1875H2.24556C1.7005 1.1875 1.2255 1.558 1.0925 2.08644L0.0178125 6.38756C0.0059375 6.43388 0 6.48256 0 6.53125C0 8.16762 1.26469 9.5 2.82031 9.5C3.724 9.5 4.53031 9.04994 5.04688 8.35169C5.56344 9.04994 6.36975 9.5 7.27344 9.5C8.17712 9.5 8.98344 9.04994 9.5 8.35169C10.0166 9.04994 10.8217 9.5 11.7266 9.5C12.6314 9.5 13.4366 9.04994 13.9531 8.35169C14.4697 9.04994 15.2748 9.5 16.1797 9.5C17.7353 9.5 19 8.16762 19 6.53125C19 6.48256 18.9941 6.43388 18.9822 6.38756Z",
    fill: "#111F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1797 10.6875C15.371 10.6875 14.6027 10.4405 13.9531 9.98924C12.654 10.8929 10.7991 10.8929 9.5 9.98924C8.20087 10.8929 6.346 10.8929 5.04688 9.98924C4.39731 10.4405 3.629 10.6875 2.82031 10.6875C2.23725 10.6875 1.68744 10.5509 1.1875 10.3182V16.625C1.1875 17.2805 1.7195 17.8125 2.375 17.8125H7.125V13.0625H11.875V17.8125H16.625C17.2805 17.8125 17.8125 17.2805 17.8125 16.625V10.3182C17.3126 10.5509 16.7627 10.6875 16.1797 10.6875Z",
    fill: "#111F3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResturantIcon);
export default __webpack_public_path__ + "static/media/resturantIcon.42167bb15530bf78a00c1886dd98eed2.svg";
export { ForwardRef as ReactComponent };